<template>
   <div class="container-fluid">
      <app-header />

      <router-view class="main-container"/>

      <app-footer />
   </div>
</template>

<script>
import Header from './Header.vue';
import Footer from './Footer.vue';

export default {
  name: 'Main',
  components: {
    appHeader: Header,
    appFooter: Footer
  }
};
</script>

<style scoped>

.container-fluid {
  padding-left: 0;
  padding-right: 0;
}
</style>
